import { Loader2, Pause, Play } from 'lucide-react';

import styles from './PlayButton.module.css';

export interface PlayButtonProps {
  playing: boolean;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  title?: string;
  ariaLabel?: string;
}

export function PlayButton({
  playing,
  onClick,
  loading = false,
  disabled = false,
  size = 'md',
  title,
  ariaLabel,
}: PlayButtonProps) {
  const cls = [
    styles.btn,
    size === 'sm' && styles.sm,
    size === 'lg' && styles.lg,
    playing && styles.on,
  ]
    .filter(Boolean)
    .join(' ');

  const icon = size === 'lg' ? 13 : size === 'md' ? 11 : 10;

  return (
    <button
      type="button"
      className={cls}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
      aria-label={ariaLabel ?? (playing ? 'Остановить' : 'Прослушать')}
      aria-pressed={playing}
    >
      {loading ? (
        <Loader2 size={icon} strokeWidth={2} className={styles.spin} />
      ) : playing ? (
        <Pause size={icon} strokeWidth={2} fill="currentColor" />
      ) : (
        <Play size={icon} strokeWidth={2} fill="currentColor" />
      )}
    </button>
  );
}
